import { z } from 'zod';
import { isValidCPF } from '@/utils/form-validators';
import { isValidEmail } from '@/utils/form-validators/email';

export const formValidationSchema = z
  .object({
    name: z
      .string()
      .min(5, 'O nome deve ter pelo menos 5 caracteres.')
      .max(255, 'O nome não pode ter mais de 255 caracteres.'),
    email: z.string().optional(),
    cpf: z.string().optional(),
    internal_employee_id: z.string().optional(),
    type_collaborator: z.string().optional(),
    position_company: z.string().optional(),
    department: z.string().optional(),
    team: z.string().optional(),
    manager_email: z.string().optional(),
    building: z.string().optional(),
    region: z.string().optional(),
    state: z.string().optional(),
    city: z.string().optional(),
    company: z.string().optional(),
    cost_center: z.string().optional(),
    is_admin: z.boolean().optional(),
    type_registration: z.enum(['email', 'cpf']).optional(),
  })
  .superRefine((data, ctx) => {
    if (data.type_registration === 'email') {
      if (!data.email) {
        ctx.addIssue({
          path: ['email'],
          code: 'custom',
          message: 'E-mail é obrigatório',
        });
      } else if (!isValidEmail(data.email)) {
        ctx.addIssue({
          path: ['email'],
          code: 'custom',
          message: 'Informe um email válido!',
        });
      }
    }

    if (data.type_registration === 'cpf') {
      if (!data.cpf) {
        ctx.addIssue({
          path: ['cpf'],
          code: 'custom',
          message: 'CPF é obrigatório',
        });
      } else if (!isValidCPF(data.cpf)) {
        ctx.addIssue({
          path: ['cpf'],
          code: 'custom',
          message: 'Informe um CPF válido',
        });
      } else if (data.cpf.length > 14) {
        ctx.addIssue({
          path: ['cpf'],
          code: 'custom',
          message: 'CPF não pode ter mais de 14 caracteres',
        });
      }
    }
  });

export type RegisterEmployerFormData = z.infer<typeof formValidationSchema>;
